<template>
    <div class="container address-page">


        <div class="body" v-if="list.length === 0">
            <div class="body-container f-s-b">
                <van-image 
                    class="body-image"
                    lazy-load
                    :src="image"
                />
                <!-- <div class="body-title">支付成功</div>
                <div class="desc">
                    <span class="price g-b-500">150.00</span>
                    <span class="unit">元</span>
                </div> -->
                <div class="body-desc">您还没添加收货地址哦</div>
                <!-- <div class="btn-box f-s-b">
                    <div class="f-c back-home">继续逛逛</div>
                    <div class="f-c look-qr">查看订单</div>
                </div> -->
            </div>
        </div>

        <!-- disabled-text="以下地址超出配送范围" -->
        <van-address-list
            :class="list.length === 0 ? 'hide-box':''"
            v-model="chosenAddressId"
            :list="list"
            :disabled-list="disabledList"
            default-tag-text="默认"
            add-button-text="新增收货地址"
            @add="onAdd"
            @edit="onEdit"
            @click-item="onChangeAddress"	
        />


        <van-popup
            class="popup-box"
            v-model="show"
            closeable
            round
            position="bottom"
        >
            <van-address-edit
                :address-info="addressInfo"
                :area-list="areaList"
                show-set-default
                show-search-result
                :tel-validator="checkPhone"
                :search-result="searchResult"
                :area-columns-placeholder="['请选择', '请选择', '请选择']"
                :show-delete="addressInfoFlag"
                @save="onSave"
                @delete="onDelete"
                :is-deleting="detFlag"
                @change-detail="onChangeDetail"
            />

        </van-popup>

    </div>
</template>

<script>
    import areaList from "./lib/area";
    import { 
        AddressEdit,
        Toast,
        AddressList,
        Popup,
    } from 'vant';
    import {
        saveUserAddrUrl,
        getUserAddrListUrl,
        delAddrUrl,
    } from '@js/shoppingUrl.js';
    import http from '@js/http-hbt.js';
    export default {
        data() {
            return {
                areaList,
                searchResult: [],
                chosenAddressId: '1',
                list: [
                    {
                        id: '1',
                        name: '张三',
                        tel: '13000000000',
                        address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室'
                    },
                    {
                        id: '2',
                        name: '李四',
                        tel: '1310000000',
                        address: '浙江省杭州市拱墅区莫干山路 50 号'
                    }
                ],
                disabledList: [
                    {
                        id: '3',
                        name: '王五',
                        tel: '1320000000',
                        address: '浙江省杭州市滨江区江南大道 15 号'
                    }
                ],
                show: false,
                image: require('@image/shopping/location.png'),
                addressInfo: {},
                addressInfoFlag: false,
                detFlag:false,
                requestParams:{
                    offset: 0,
                    psize: 20,
                },
                defaultType: '',//..默认类型页面点击的时候不做任何事情
                tapFalg: false,
            }
        },
        created() {
            this.disabledList = [];
            // setTimeout(() => {
            //     this.list = [];
            // }, 1000);
            this.list = [];

            var {
                type = ''
            } = this.$route.query;
            this.defaultType = type;

            this.getUserAddrList();
        },
        methods: {
            onAdd() {
                this.addressInfo = {};
                this.show = !this.show;
                this.addressInfoFlag = false;
            },
            onEdit(item, index) {
                //  阻止单次单机的时候的事件效果带来的影响
                //      阻止事件冒泡不行.
                this.tapFalg = true;
                setTimeout(() => {
                    this.tapFalg = false;
                }, 500);
                var {
                    rawData
                } = item;
                var array = String(rawData.detailaddress).split(' '),  
                    addressDetail = '';
                if(array.length >0){
                    addressDetail = array[1]
                }
                var addressInfo = {
                    id: rawData.id,
                    name: rawData.contact,
                    tel: rawData.telno,
                    province: rawData.provinceid,
                    city: rawData.cityid,
                    county: rawData.countyid,
                    addressDetail,
                    areaCode: rawData.countyid,
                    postalCode: rawData.postCode,
                    isDefault: rawData.type === "1"? true:false,
                    rawData,
                } 
                this.onAdd();
                this.addressInfoFlag = true;
                this.addressInfo = addressInfo;
            },
            onSave(content) {
                this.commit(content)
            },
            commit(content){
                var provinceCode = '',
                    cityCode = '',
                    areaCode = '';
                var {
                    province_list,
                    city_list,
                    county_list,
                } = areaList;
                // var s = `"{"name":"15","tel":"15928176933","country":"","province":"北京市","city":"北京市","county":"西城区","areaCode":"110102","postalCode":"","addressDetail":"15928176933","isDefault":false}"`
                
                //  备注: 手动获取编码是因为有时候 省市是同一个的时候 回调里面的参数有些不一样 就自己遍历了
                for(let key  in province_list){
                    if(province_list[key] === content.province){
                        provinceCode = key;
                    }
                }
                for(let key  in city_list){
                    if(city_list[key] === content.city){
                        cityCode = key;
                    }
                }
                for(let key  in county_list){
                    if(county_list[key] === content.county){
                        areaCode = key;
                    }
                }
                var data = {
                    id: content.id || '',//新增为空 编辑传入地址id
                    userId: this.getUserId,
                    detailAddress: `${content.province}${content.city}${content.county} ${content.addressDetail}`,
                    telNo: content.tel,
                    contact: content.name,
                    type: content.isDefault ? '1':'2',//..类型(1 是默认地址，2，普通地址 )
                    postCode: '',//邮编
                    idCard: '',//身份证
                    //  省市区编码
                    provinceCode,
                    cityCode,
                    areaCode,
                    remark: '',//..备注
                }
                http.post(saveUserAddrUrl,data)
                    .then(res=>{
                        this.$toast.success('保存成功');
                        this.dataCallBack();
                    })
            },
            onDelete() {
                this.detFlag = !this.detFlag;
                var {
                    id
                } = this.addressInfo;
                http.post(delAddrUrl,{id})
                    .then(res=>{
                        this.detFlag = !this.detFlag;
                        this.$toast.success('删除成功');
                        this.dataCallBack();
                    })
            },
            dataCallBack(){
                this.addressInfo = {};
                this.list = [];
                this.getUserAddrList();
                this.onAdd();
            },
            checkPhone(v){
                return /^1[3456789]\d{9}$/.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            getUserAddrList(){
                http.post(getUserAddrListUrl,{
                    userId: this.getUserId,
                    offset: this.requestParams.offset,
                    psize: this.requestParams.psize,
                }).then(res=>{
                    var {
                        data: array
                    } = res;
                    array.map(item=>{
                        if(item.type === "1"){
                            this.chosenAddressId = item.id
                        }
                        this.list.push({
                            id: item.id,
                            name: item.contact,
                            tel: item.telno,
                            address: item.detailaddress,
                            isDefault: item.type === "1" ? true : false ,
                            rawData: item,
                        })
                    })
                    if(this.chosenAddressId === "1" && this.list.length>0){
                        this.chosenAddressId = this.list[0].id
                    }
                })
            },
            onChangeDetail(val) {
                if (val) {
                    // this.searchResult = [{
                    //     name: '黄龙万科中心',
                    //     address: '杭州市西湖区'
                    // }];
                } else {
                    this.searchResult = [];
                }
            },
            onChangeAddress(res){
                if(this.tapFalg) return;
                var {
                    name,
                    tel: phone,
                    address,
                } = res;
                var data = {
                    name,
                    phone,
                    address,
                }
                if(this.defaultType === 'changeContacts'){
                    // this.$store.commit('setShopCarContacts',data);
                    sessionStorage.setItem('temp-set-shop-car-contacts', JSON.stringify(data))
                    this.$router.go(-1)
                }
            }
        },
        computed: {
            getUserId(){
                return this.$store.state.userInfo.userId || ''
            },
        },
        watch: {
            show(v){
                if(v){
                    window.document.title = '添加收货地址'
                }else{
                    window.document.title = '收货地址'
                }
            }
        },
        components:{
            [AddressEdit.name]:AddressEdit,
            [AddressList.name]:AddressList,
            [Popup.name]:Popup,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .hide-box{
        height: 0;
    }
    .container{
        height: ~"calc(100% - 50px)" !important;
        padding-bottom: 13px;
        .popup-box{
            padding-top: 25px;
            box-sizing: border-box;
        }     
        .body{
            position: relative;
            box-sizing: border-box;
            // height: 100%;
            // min-height: 506px;
            padding: 20px 7px;
            .body-container{
                justify-content: flex-start;
                box-sizing: border-box;
                flex-direction: column;
                padding: 35px 30px 45px;
                width: 100%;
                // height:100%;
                background:rgba(255,255,255,1);
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                border-radius:5px;
                .body-image{
                    width: 200px;
                    height: 175px;
                }
                .body-title{
                    margin-top: 30px;
                    font-size:18px;
                    font-weight:600;
                    color: #365C84;
                }
                .desc{
                    // margin-top: 6px;
                    margin: 18px 0;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(71,75,78,1);
                    .price{
                        color:#FF9824;
                        font-size: 18px;
                    }
                    .unit{
                        font-size: 14px;
                    }
                }
                .body-desc{
                    margin-top: 30px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(98,98,98,1);
                }
                .btn-box{
                    margin-top: 74px;
                    width: 100%;
                    .back-home{
                        color: #ffffff;
                        width:135px;
                        height:37px;
                        border-radius:5px;
                        background:rgba(92,162,253,1);
                        // border:1px solid rgba(105,170,254,1);
                    }
                    .look-qr{
                        color: #626262;
                        width:135px;
                        height:37px;
                        // background:rgba(92,162,253,1);
                        background:rgba(237,237,237,1);
                        border-radius:5px;
                    }
                }
            }
        }
    }
</style>